import '../layouts/ansysoft.css';
import rightArrow from '../assets/right-arrow.svg'
import arrowDown from '../assets/arrow-down.svg'
import { Link } from 'react-router-dom';
import Footer from '../components/footer';

function OurCommunity() {
    return (
        <>
            <div className="w-100 banner-bg-community">
                <div className="container banner-bg-2">
                    <div className="banner-wrap-community">
                        <div className="banner-community">
                            <h1 className="heading-1-community"><span>WebBull</span> is for everyone</h1>
                            <p className="description-1-community mt-3 mt-md-5">Our community-based membership plans offer a range of benefits
                                and opportunities for individuals to engage and participate in a collective environment.</p>
                                {/* btn btn-outline banner-btn mt-2 mt-md-4 */}
                            <Link to="/signin" className="btn-main community-width  btn-outline-main">
                                    JOIN NOW 
                                <img src={rightArrow}alt="===>" className='arrow' width="36" height="100%"/>
                            </Link>
                        </div>
                    </div>
                </div>
            </div>
            <div className="w-100 benefits-bg">
                <div className="container benefits">
                    <div className="heading-2">Benefits</div>
                    <div className="para-2 mt-3">WebBull serves as a bridge that brings individuals from different corners of the
                        world together, connecting them in a common pursuit of financial growth, knowledge sharing, and
                        collaborative success. It transcends physical boundaries and fosters a global community that thrives on
                        the power of connection and diversity.</div>
                    <img src={arrowDown} alt="\/" class="mt-5"/>
                </div>
            </div>
            <div className="w-100 points-group">
                <div className="point text-first">
                    <div className="p-box box-img-1"></div>
                    <div className="p-box box-text">
                        <h2 className="box-heading">100% Decentralized</h2>
                        <p className="box-para">Introducing a groundbreaking innovation: The world's first decentralized matrix
                            marketing powered by blockchain, exclusively built on BUSD.</p>
                    </div>
                </div>
                <div className="point image-first">
                    <div className="p-box box-img-2"></div>
                    <div className="p-box box-text">
                        <h2 className="box-heading">Immediate Rewards</h2>
                        <p className="box-para">WebBull instantly distributing cryptocurrency rewards within matrix structures to
                            participants, ensuring secure and direct transactions without storing funds.</p>
                    </div>
                </div>
                <div className="point text-first">
                    <div className="p-box box-img-3"></div>
                    <div className="p-box box-text">
                        <h2 className="box-heading">Unstoppable</h2>
                        <p className="box-para">BUSD Blockchain ensuring uninterrupted operations and immutable logic, shielding
                            against interference or modification.</p>
                    </div>
                </div>
                <div className="point image-first">
                    <div className="p-box box-img-4"></div>
                    <div className="p-box box-text">
                        <h2 className="box-heading">Community Driven</h2>
                        <p className="box-para">We value the contributions of all members in our rapidly growing community. We
                            encourage everyone to help and support each other, so that we can all grow and thrive together.</p>
                    </div>
                </div>
            </div>
            <Footer/>
        </>
    )
}

export default OurCommunity;